import { useMutation, useQueryClient } from '@tanstack/react-query';
import { membershipsKey, workspaceKey } from './workspace.api';

/**
 * Mutation scoped to one workspace. On success every cached query of the workspace is refetched,
 * because governance/equity changes ripple into the cabinet, directory and audit log.
 */
export function useWorkspaceMutation<TVariables, TResult>(
  workspaceId: string,
  mutationFn: (variables: TVariables) => Promise<TResult>,
  options: { readonly refreshMemberships?: boolean } = {},
) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: workspaceKey(workspaceId) }),
        options.refreshMemberships === true
          ? queryClient.invalidateQueries({ queryKey: membershipsKey })
          : Promise.resolve(),
      ]);
    },
  });
}
